import skyBluePencil from "../../appAssets/jsons/skybluePencil.json";
import skybluebrush from "../../appAssets/jsons/skyblue.json";
import redPencil from "../../appAssets/jsons/redpencil.json";
import redbrush from "../../appAssets/jsons/redbrush.json";
import yellowPencil from "../../appAssets/jsons/yellowPencil.json";
import yellowbrush from "../../appAssets/jsons/yellowbrush.json";
import greenPencil from "../../appAssets/jsons/greenPencil.json";
import greenbrush from "../../appAssets/jsons/greenbrush.json";
import blackPencil from "../../appAssets/jsons/blackPencil.json";
import blackbrush from "../../appAssets/jsons/blackbrush.json";
import orangePencil from "../../appAssets/jsons/orangepencil.json";
import orangebrush from "../../appAssets/jsons/orangebrush.json";
import pinkPencil from "../../appAssets/jsons/pinkPencil.json";
import pinkbrush from "../../appAssets/jsons/pinkbrush.json";
import purplePencil from "../../appAssets/jsons/purplepencil.json";
import purpleBrush from "../../appAssets/jsons/purpleBrush.json";
import whitePencil from "../../appAssets/jsons/whitePencil.json";
import whitebrush from "../../appAssets/jsons/whitebrush.json";
import brownPencil from "../../appAssets/jsons/brownPencil.json";
import brownbrush from "../../appAssets/jsons/brownbrush.json";
import eraser_icon from "../../appAssets/jsons/eraser.json";

export const workSheetColors = [
  "#0092D3",
  "#EB281D",
  "#F4C500",
  "#88BA00",
  "#000000",
  "#FF642E",
  "#F54480",
  "#7C3DB9",
  "#873A04",
  "#FFFFFF",
];

export const pencilBox = [
  {
    id: 1,
    iconName: skyBluePencil,
    brushName: skybluebrush,
    isSelected: false, // Default selection
    type: "edit",
    color: workSheetColors[0], // Sky Blue
  },
  {
    id: 6,
    iconName: redPencil,
    brushName: redbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[1], // Red
  },
  {
    id: 4,
    iconName: yellowPencil,
    brushName: yellowbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[2], // Yellow
  },
  {
    id: 3,
    iconName: greenPencil,
    brushName: greenbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[3], // Green
  },
  {
    id: 7,
    iconName: blackPencil,
    brushName: blackbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[4], // Black
  },
  {
    id: 5,
    iconName: orangePencil,
    brushName: orangebrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[5], // Orange
  },

  {
    id: 10,
    iconName: pinkPencil,
    brushName: pinkbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[6], // pink
  },
  {
    id: 2,
    iconName: purplePencil,
    brushName: purpleBrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[7], // Purple
  },

  {
    id: 8,
    iconName: whitePencil,
    brushName: whitebrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[9], // White
  },
  {
    id: 9,
    iconName: brownPencil,
    brushName: brownbrush,
    isSelected: false,
    type: "edit",
    color: workSheetColors[8], // Brown
  },
  {
    id: 9,
    iconName: eraser_icon,
    isSelected: false,
    type: "eraser",
    color: workSheetColors[9], // White for eraser effect
  },
];

// Tablet-only sizing (mobile values for isTablet() === true)
export const STICKER_SIZE = 100; // web canvas — larger for visibility on big screens
export const ARROW_SIZE = 56; // mobile: scaleSize(28)
export const STICKERS_PER_PAGE = 4; // mobile tablet value

export type DrawingType = "doodle" | "color";
export type ActiveTool = "pencil" | "brush" | "eraser";

export interface BrushSize {
  id: number;
  brushSize: number; // stroke width
  width: number; // visual diameter of the selector dot
}

// Tablet brush sizes (4 options)
export const BRUSH_SIZES: BrushSize[] = [
  { id: 1, brushSize: 5, width: 16 },
  { id: 2, brushSize: 10, width: 22 },
  { id: 3, brushSize: 15, width: 28 },
  { id: 4, brushSize: 20, width: 34 },
];

// Stickers — same URLs as the mobile STICKERS array
export const STICKERS = [
  {
    id: "lion",
    image: "https://assets.prod.yetimyfriend.com/lion_38f4d64f99.png",
  },
  {
    id: "strawberry",
    image: "https://assets.prod.yetimyfriend.com/strawberry_c6c32ed3b0.png",
  },
  {
    id: "tv",
    image: "https://assets.prod.yetimyfriend.com/sandwich_8b5b369c23.png",
  },
  {
    id: "bear",
    image: "https://assets.prod.yetimyfriend.com/teddy_7629ed5fba.png",
  },
  {
    id: "crown",
    image: "https://assets.prod.yetimyfriend.com/crown_eede205ffe.png",
  },
  {
    id: "image_5",
    image: "https://assets.prod.yetimyfriend.com/image_5_5370c2e6ae.png",
  },
  {
    id: "image_6",
    image: "https://assets.prod.yetimyfriend.com/image_6_6775eb7ca9.png",
  },
  {
    id: "image_7",
    image: "https://assets.prod.yetimyfriend.com/image_7_0b8cc19fba.png",
  },
  {
    id: "image_8",
    image: "https://assets.prod.yetimyfriend.com/image_8_5091387fb5.png",
  },
  {
    id: "image_9",
    image: "https://assets.prod.yetimyfriend.com/image_9_a412fd3210.png",
  },
  {
    id: "image_10",
    image: "https://assets.prod.yetimyfriend.com/image_10_ae74a824d9.png",
  },
  {
    id: "image_11",
    image: "https://assets.prod.yetimyfriend.com/image_11_cba0edad38.png",
  },
];

export interface Path {
  d: string;
  color: string;
  width: number;
  tool: ActiveTool;
}

export interface PlacedSticker {
  key: string;
  id: string;
  image: string;
  x: number;
  y: number;
}

// Mirrors mobile config.ts getRandomSheet
export function getRandomSheet<T>(arr: T[]): T | undefined {
  if (!arr || arr.length === 0) return undefined;
  const idx = Math.floor(Math.random() * arr.length);
  return arr[idx];
}
